__turbopack_context__.v({
  "root": "BuiltByBert-module-scss-module__r8jkUG__root",
});
